/* Scope hover zoom to this gallery. Videos never enter the image zoom path. */
if (!customElements.get('rth-product-media-controller')) {
  customElements.define('rth-product-media-controller', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.gallery = this.closest('.product-media-gallery-wrap');
      this.main = this.gallery?.querySelector('.product-media-main-wrapper');
      this.panel = this.gallery?.querySelector('.yg-zoomIn-image-wrapper');
      this.mask = this.main?.querySelector('.yg-mask');
      if (!this.main || !this.panel || !this.mask) return;
      this.pointer = window.matchMedia('(min-width: 991px) and (hover: hover) and (pointer: fine)');
      this.main.addEventListener('pointermove', (event) => this.queueZoom(event), options);
      this.main.addEventListener('pointerleave', () => this.clearZoom(), options);
      window.addEventListener('resize', () => this.clearZoom(), options);
      window.addEventListener('scroll', () => this.clearZoom(), { ...options, passive: true });
      this.observer = new MutationObserver(() => {
        const current = this.main.querySelector('.product-media-main.is-active');
        if (current !== this.activeCell) this.clearZoom();
      });
      this.main.querySelectorAll('.product-media-main').forEach((cell) => {
        this.observer.observe(cell, { attributes: true, attributeFilter: ['class'] });
      });
    }

    queueZoom(event) {
      const cell = event.target.closest('.product-media-main[data-media-type="image"]');
      if (!this.pointer.matches || !cell?.classList.contains('is-active') ||
          !cell.querySelector('modal-opener') || event.target.closest('.product-media-slider-nav')) {
        this.clearZoom();
        return;
      }
      this.point = { x: event.clientX, y: event.clientY, cell };
      if (!this.frame) this.frame = requestAnimationFrame(() => this.drawZoom());
    }

    drawZoom() {
      this.frame = 0;
      const { x, y, cell } = this.point;
      const bounds = this.main.getBoundingClientRect();
      // Keep the existing side-by-side magnifier within the viewport.
      const panelWidth = Math.min(600, window.innerWidth - bounds.right - 45);
      if (panelWidth < 160 || bounds.width <= 0) {
        this.clearZoom();
        return;
      }
      if (this.activeCell !== cell) {
        this.clearZoom();
        this.activeCell = cell;
        this.activeZoom = [...this.panel.querySelectorAll('[data-zoom-media-id]')]
          .find((item) => item.dataset.zoomMediaId === cell.dataset.mediaId);
        if (!this.activeZoom) return;
        const template = this.activeZoom.querySelector('template');
        if (!this.activeZoom.querySelector('img') && template) {
          this.activeZoom.append(template.content.cloneNode(true));
        }
        this.activeZoom.classList.add('active');
      }
      if (!this.activeZoom) return;
      const img = this.activeZoom.querySelector('img');
      if (!img) return;
      const zoomSize = bounds.width * 2;
      const lensSize = panelWidth / 2;
      const left = Math.max(0, Math.min(x - bounds.left - lensSize / 2, bounds.width - lensSize));
      const top = Math.max(0, Math.min(y - bounds.top - lensSize / 2, bounds.height - lensSize));
      this.panel.style.width = `${panelWidth}px`;
      this.panel.style.height = `${panelWidth}px`;
      this.mask.style.width = this.mask.style.height = `${lensSize}px`;
      this.mask.style.left = `${left}px`;
      this.mask.style.top = `${top}px`;
      img.style.width = img.style.height = `${zoomSize}px`;
      img.style.left = `${-left * 2}px`;
      img.style.top = `${-top * 2}px`;
      this.mask.classList.add('active');
      this.panel.classList.add('active');
    }

    clearZoom() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.activeZoom?.classList.remove('active');
      this.mask?.classList.remove('active');
      this.panel?.classList.remove('active');
      this.activeCell = null;
      this.activeZoom = null;
    }

    disconnectedCallback() {
      this.clearZoom();
      this.observer?.disconnect();
      this.events?.abort();
      this.events = null;
    }
  });
}
